export const isTranslationNeeded = (value) => !value || !value["de"] || !value["en"] || !value["fr"]
